import React from 'react';
import { Modal, StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { Button } from './Button';
import { useProfileNudge } from '../hooks/useProfileNudge';
import { colors, radius, screenPadding, spacing, typography } from '../theme/tokens';
import { t } from '../i18n';

interface ProfileNudgeModalProps {
  // Vrai seulement après les gates obligatoires (session + CGU + date de naissance).
  active: boolean;
  // Navigation vers Réglages → Infos perso (fournie par RootNavigator qui détient navigationRef).
  onComplete: () => void;
}

// Pop-up non bloquant de relance : incite à compléter les infos perso qui alimentent les CV.
// (Distinct de ProfileCompletionScreen, qui est une gate post-auth.)
export function ProfileNudgeModal({ active, onComplete }: ProfileNudgeModalProps) {
  const { visible, dismiss } = useProfileNudge(active);

  const complete = () => {
    onComplete();
    dismiss();
  };

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={dismiss}>
      {visible ? (
        <View style={styles.backdrop}>
          <View style={styles.card} testID="profile-nudge-modal">
            <Text style={styles.title}>{t('misc.completeProfile')}</Text>
            <Text style={styles.body}>
              Renseigne tes infos perso pour que tes CV générés soient au top.
            </Text>
            <View style={styles.actions}>
              <Button title={t('misc.completeProfileCta')} onPress={complete} testID="nudge-complete" />
              <Button title={t('misc.later')} variant="secondary" onPress={dismiss} testID="nudge-later" />
            </View>
          </View>
        </View>
      ) : null}
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(7, 27, 77, 0.55)', // night à 55% : voile cohérent avec la charte
    alignItems: 'center',
    justifyContent: 'center',
    padding: screenPadding,
  },
  card: {
    width: '100%',
    gap: spacing.md,
    padding: spacing.xl,
    borderRadius: radius.lg,
    backgroundColor: colors.white,
  },
  title: { fontSize: typography.h2.size, fontWeight: typography.h2.weight, color: colors.grey900 },
  body: { fontSize: typography.body.size, color: colors.grey700 },
  actions: { gap: spacing.sm, marginTop: spacing.xs },
});
